import { createAction } from 'redux-actions'

export const storeKeys = createAction('STORE_KEYS')
export const unlockPrivateKey = createAction('UNLOCK_PRIVATE_KEY')
export const unlockPrivateKeyStart = createAction('UNLOCK_PRIVATE_KEY_START')
export const unlockPrivateKeySuccess = createAction(
  'UNLOCK_PRIVATE_KEY_SUCCESS'
)
export const unlockPrivateKeyError = createAction('UNLOCK_PRIVATE_KEY_ERROR')
export const unlockPrivateKeyWrongPassword = createAction(
  'UNLOCK_PRIVATE_KEY_WRONG_PASSWORD'
)



// WEBPACK FOOTER //
// ./src/services/crypto/actions.js